import moment from 'moment'
import CONSTANTS from '../utils/order.json'
export default {
  data () {
    return {
      imagesTypes: ['image/bmp', 'image/png', 'image/jpeg', 'image/jpeg']
    }
  },
  computed: {
    $_requiredValidation () {
      return [val => !!val || 'Required']
    },
    $_selectRequiredValidation () {
      return [
        val => val >= 0 || 'Required'
      ]
    },
    $_multiSelectValidation () {
      return [
        val => !!val || 'Required',
        val => (val && val.length > 0) || 'Required'
      ]
    },
    $_MobileNumberValidation () {
      return [
        /* val => !!val || this.$t('message.common.required'), */
        val => {
          if (!val) {
            return true
          }
          const regex = /^([+]?)(?:[0-9] ?){4,14}[0-9]$/
          return regex.test(val) || this.$t('message.common.invalidMobileno')
        }
      ]
    },
    $_invoiceValidation () {
      return [
        val => (val) ? /^-?[0-9.,]+$/.test(val) || this.$t('message.common.invalidNumber') : true,
        val => (val) ? !isNaN(this.$formatter.replaceCommaWithDot(val)) || this.$t('message.common.invalidNumber') : true
      ]
    },
    $_numberValidation () {
      return [
        val => (val) ? /^[0-9]+$/.test(val) || 'Not Valid Number' : true,
        val => (val) ? !isNaN(this.$formatter.replaceCommaWithDot(val)) || 'Not Valid Number' : true
      ]
    },
    $_requiredAndMinValidation () { /* min val is 5 */
      return [
        v => !!v || 'Required',
        v => (v > 4) || 'Minimum width is 5%'
      ]
    },
    $_norwegianNumberValidation () {
      return [
        val => (val) ? /^[0-9.,]+$/.test(val) || 'Not Valid Number' : true,
        val => (val) ? !isNaN(this.$formatter.replaceCommaWithDot(val)) || 'Not Valid Number' : true
      ]
    },
    $_norwegianNumberMinusValidation () {
      return [
        val => (val) ? /^-?[0-9.,]+$/.test(val) || 'Not Valid Number' : true,
        val => (val) ? !isNaN(this.$formatter.replaceCommaWithDot(val)) || 'Not Valid Number' : true
      ]
    },
    $_emailValidation () {
      return [
        (v) => v ? /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/.test(v) || 'Invalid Email Address' : true
      ]
    },
    $_multiEmailValidation () {
      return [
        (v) => {
          if (!v) return true
          const emails = v.split(',').map(email => email.trim()).filter(email => email)
          if (emails.length === 0) return true
          const emailRegex = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/
          const invalidEmails = emails.filter(email => !emailRegex.test(email))
          return invalidEmails.length === 0 || `Invalid email address(es): ${invalidEmails.join(', ')}`
        }
      ]
    },
    $_phoneValidation () {
      return [
        (v) => v ? /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(v) || 'Invalid Phone Number' : true
      ]
    },
    $_discountValidation () {
      return [
        (val) => val ? (this.$formatter.replaceCommaWithDot(val) <= 100 && this.$formatter.replaceCommaWithDot(val) >= 0) || 'Invalid Number' : true
      ]
    },
    $_fileValidation () {
      return [value => !value || value.size < 200000000 || 'File Required']
    },
    $_fileTypeValidation () {
      // eslint-disable-next-line
      return [value => !!value ? true : 'File Required']
    },
    $_HourValidation () {
      return [
        val => !!val || 'Required',
        val => this.$formatter.replaceCommaWithDot(val) <= 24 || 'Invalid Hours'
      ]
    },
    $_weekValidation () {
      return [
        val => val ? this.$formatter.replaceCommaWithDot(val) >= 0 || this.$t('message.common.invalidWeekNumber') : true,
        val => val ? this.$formatter.replaceCommaWithDot(val) <= 53 || this.$t('message.common.invalidWeekNumber') : true
      ]
    },
    $_YearHourValidation () {
      return [
        val => !!val || 'Required',
        val => this.$formatter.replaceCommaWithDot(val) <= 8784 || 'Invalid Hours'
      ]
    },
    $_spaceAndRequiredValidation () {
      return [
        (v) => !!(v) || 'Required', (v) => v ? /^[^-\s][a-zA-Z0-9_\s-]+$/.test(v) || 'Cannot start with spac' : true
      ]
    },
    $_discountWithMinusValidation () {
      return [
        (val) => val ? (this.$formatter.replaceCommaWithDot(val) <= 100) || 'Invalid Number' : true
      ]
    },
    $_emailAndRequiredValidation () {
      return [
        (v) => !!(v) || 'Required', (v) => v ? /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/.test(v) || 'Invalid Email Address' : true
      ]
    },
    $_domainAndRequiredValidation () {
      return [
        (v) => !!(v) || 'Required', (v) => v ? /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/.test(v) || 'Invalid Domain Address' : true
      ]
    },
    $_deviationSeverity () {
      return [
        { text: this.$t('message.severity.low'), value: 'low' },
        { text: this.$t('message.severity.medium'), value: 'medium' },
        { text: this.$t('message.severity.high'), value: 'high' }
      ]
    },
    $_PERMISSIONS_LIST () {
      return [{
        text: 'message.permissions.manageShifts',
        id: 100
      }, {
        text: 'message.permissions.manageOpencartOrders',
        id: 101
      }, {
        text: 'message.permissions.manageShopboxOrders',
        id: 102
      }, {
        text: 'message.permissions.manageSettings',
        id: 103
      }]
    },
    $_languagesList () {
      return [
        { title: this.$t('message.common.norwegian'), value: 'no' },
        { title: this.$t('message.common.english'), value: 'en' }
      ]
    },
    $_locations () {
      return [
        { text: this.$t('message.customer.norwegianLoc'), value: 'norwegian' },
        { text: this.$t('message.customer.foreign'), value: 'foreign' }
      ]
    },
    $_listOfAddressTypes () {
      return [
        { title: this.$t('message.customer.visit'), value: 'visit' },
        { title: this.$t('message.customer.post'), value: 'post' },
        { title: this.$t('message.customer.invoice'), value: 'invoice' },
        { title: this.$t('message.customer.delivery'), value: 'delivery' }
      ]
    },
    $_listOfCustomerStates () {
      return [
        { name: this.$t('message.customer.buyingCustomer'), id: 1 },
        { name: this.$t('message.customer.potentialCustomer'), id: 2 },
        { name: this.$t('message.order.supplier'), id: 3 }
      ]
    },
    $_orderStatus () {
      return [{
        text: this.$t('message.common.draft'),
        value: 'draft'
      }, {
        text: this.$t('message.common.ready'),
        value: 'ready'
      }, {
        text: this.$t('message.common.inProgress'),
        value: 'inprogress'
      }, {
        text: this.$t('message.common.ordered'),
        value: 'ordered'
      }, {
        text: this.$t('message.common.received'),
        value: 'received'
      }, {
        text: this.$t('message.common.partiallyReceived'),
        value: 'partiallyreceived'
      }, {
        text: this.$t('message.common.request'),
        value: 'request'
      }, {
        text: this.$t('message.common.partiallyPicked'),
        value: 'partiallypicked'
      }, {
        text: this.$t('message.common.picked'),
        value: 'picked'
      }]
    },
    $_priorityList () {
      return [{
        text: this.$t('message.common.low'), value: 'low'
      }, {
        text: this.$t('message.common.medium'), value: 'medium'
      }, {
        text: this.$t('message.common.high'), value: 'high'
      }]
    },
    $_ccsheetStatus () {
      return [{
        text: 'message.ccsheet.ongoing',
        value: 'ongoing'
      }, {
        text: 'message.ccsheet.counted',
        value: 'counted'
      }, {
        text: 'message.ccsheet.recount',
        value: 'recount'
      }, {
        text: 'message.ccsheet.completed',
        value: 'completed'
      }, {
        text: 'message.ccsheet.completedAndAdjusted',
        value: 'completed_and_adjusted'
      }]
    },
    $_orderType () {
      return [{ text: this.$t('message.whOrder.supplierOrder'), value: 'supplier' },
        { text: this.$t('message.whOrder.adjustmentOrder'), value: 'adjustment' },
        { text: this.$t('message.whOrder.returnOrder'), value: 'return' },
        { text: this.$t('message.whOrder.transferOrder'), value: 'transfer' }]
    },
    $_orderOfferStatus () {
      return [{
        name: this.$t('message.orders.salenew'), id: CONSTANTS.REQUEST, is_order: false, issales: true, value: 'sales'
      }, {
        name: this.$t('message.layout.offer'), id: CONSTANTS.OFFER, is_order: false, issales: true, value: 'sales'
      }, {
        name: this.$t('message.orders.sold'), id: CONSTANTS.SOLD, is_order: false, issales: true, value: 'sales'
      }, {
        name: this.$t('message.orders.lost'), id: CONSTANTS.LOST, is_order: false, issales: true, value: 'sales'
      }, {
        name: this.$t('message.common.new'), id: CONSTANTS.NEW, is_order: false, value: 'offer'
      }, {
        name: this.$t('message.common.sent'), id: CONSTANTS.SENT, is_order: false, value: 'offer'
      }, {
        name: this.$t('message.common.accepted'), id: CONSTANTS.ACCEPTED, is_order: false, value: 'offer'
      }, {
        name: this.$t('message.common.createOrder'), id: CONSTANTS.CREATE_ORDER, is_order: false, value: 'offer'
      }, {
        name: this.$t('message.common.notAccepted'), id: CONSTANTS.NOT_ACCEPTED, is_order: false, value: 'offer'
      }, {
        name: this.$t('message.orders.forProduction'), id: CONSTANTS.FOR_PRODUCTION, is_order: true, value: 'order'
      }, {
        name: this.$t('message.orders.pick'), id: CONSTANTS.PICK, is_order: true, value: 'order'
      }, {
        name: this.$t('message.orders.forApproval'), id: CONSTANTS.FOR_APPROVAL, is_order: true, value: 'order'
      }, {
        name: this.$t('message.orders.toInvoice'), id: CONSTANTS.TO_INVOICE, is_order: true, value: 'order'
      }, {
        name: this.$t('message.orders.invoiced'), id: CONSTANTS.INVOICED, is_order: true, value: 'order'
      }, {
        name: this.$t('message.orders.projectCompleted'), id: CONSTANTS.PROJECT_COMPLETED, is_order: true, value: 'order'
      }, {
        name: this.$t('message.orders.cancelled'), id: CONSTANTS.CANCELLED, is_order: true, value: 'order'
      }]
    },
    listOfUserRoles () {
      return [
        { name: this.$t('message.userRole.administrator'), id: 1 },
        { name: this.$t('message.userRole.office'), id: 2 },
        { name: this.$t('message.userRole.technician'), id: 3 }
      ]
    },
    invoiceType () {
      return [{
        text: this.$t('message.customer.invoice'),
        value: 1
      }, {
        text: this.$t('message.invoice.creditNote'),
        value: 2
      }]
    },
    invoiceStatus () {
      return [{
        text: this.$t('message.common.draft'),
        value: 'draft'
      }, {
        text: this.$t('message.invoice.toBeExported'),
        value: 2
      }, {
        text: this.$t('message.invoice.exported'),
        value: 1
      }, {
        text: this.$t('message.common.completed'),
        value: 'completed'
      }]
    },
    listOfPaymentTerm () {
      return [
        { name: `0 ${this.$t('message.invoice.days')}`, id: 0 },
        { name: `5 ${this.$t('message.invoice.days')}`, id: 5 },
        { name: `7 ${this.$t('message.invoice.days')}`, id: 7 },
        { name: `10 ${this.$t('message.invoice.days')}`, id: 10 },
        { name: `14 ${this.$t('message.invoice.days')}`, id: 14 },
        { name: `15 ${this.$t('message.invoice.days')}`, id: 15 },
        { name: `20 ${this.$t('message.invoice.days')}`, id: 20 },
        { name: `25 ${this.$t('message.invoice.days')}`, id: 25 },
        { name: `30 ${this.$t('message.invoice.days')}`, id: 30 },
        { name: `40 ${this.$t('message.invoice.days')}`, id: 40 },
        { name: `45 ${this.$t('message.invoice.days')}`, id: 45 },
        { name: `60 ${this.$t('message.invoice.days')}`, id: 60 }
      ]
    },
    listOfStatus () {
      return [{
        id: 'draft',
        name: this.$t('message.common.draft')
      }, {
        id: 'completed',
        name: this.$t('message.common.completed')
      }]
    }
  },
  methods: {
    getRoundedNumberWithPrecision (num, decimalPlaces = 2) {
      var p = Math.pow(10, decimalPlaces)
      var n = (num * p) * (1 + Number.EPSILON)
      return Math.round(n) / p
    },
    $_maxCharValidation (count) {
      return [
        val => !!val || 'Required',
        val => (val && val.toString().length && val.toString().length <= count) || this.$t('message.common.maxCharacters', { charCount: count })
      ]
    },
    $_replaceDotWithComma (value) {
      if (value === null || value === undefined || value === '') return ''
      if (value.toString().includes(',')) return value
      var p = Math.pow(10, 2)
      var n = (value * p) * (1 + Number.EPSILON)
      const result = Math.round(n) / p
      return result.toFixed(2).toString().replace('.', ',')
    },
    $_replaceDotWithCommaNotFixed (value) {
      if (value === null || value === undefined || value === '') return ''
      return Number(Math.floor(parseFloat(value))).toString()
    },
    $_replaceDotWithCommaIfHasDecimal (value) {
      if (value === null || value === undefined || value === '') return ''
      if (value.toString().includes(',')) return value
      var p = Math.pow(10, 2)
      var n = (value * p) * (1 + Number.EPSILON)
      const result = Math.round(n) / p
      return result.toString().replace('.', ',')
    },
    $_replaceCommaWithDot (value) {
      if (!value) return ''
      return value.toString().replace(',', '.')
    },
    $_thousandSeparator (value, deciamlVal = 2) {
      if (value === null || value === undefined || value === '') return ''
      var p = Math.pow(10, deciamlVal)
      var n = (value * p) * (1 + Number.EPSILON)
      const result = Math.round(n) / p
      const total = result.toFixed(2).toString().replace('.', ',')
      return (total.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 '))
    },
    $_filterDate (date) {
      if (!date) return null
      return moment(date, 'DD.MM.YYYY').isValid() ? moment(date, 'DD.MM.YYYY').format('DD.MM.YYYY') : null
    },
    $_formatDate (date, fromFormat, toFormat) {
      if (!date) return null
      return moment(date, fromFormat).isValid() ? moment(date, fromFormat).format(toFormat) : null
    },
    $_filterDateTime (date) {
      if (!date) return null
      return moment(date, 'DD.MM.YYYY HH:mm:ss').isValid() ? moment(date, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY HH:mm:ss') : null
    },
    $_getRandomNumberInBW (min, max) {
      return parseInt(Math.random() * (max - min) + min)
    },
    $_isArrayHasData (array) {
      if (array && array.length > 0) return true
      else return false
    },
    // _getSumBy([4, 2, 8, 6]) // 20
    $_getSum (arr) {
      return [...arr].reduce((acc, val) => acc + val, 0)
    },
    // _getSumBy([{ n: 4 }, { n: 2 }, { n: 8 }, { n: 6 }], x => x.n) // 20
    $_getSumBy (arr, fn) {
      let self = this
      if (this.$_isArrayHasData(arr)) {
        return arr.map(typeof fn === 'function' ? fn : val => val[fn]).reduce(function (acc, val) {
          return self.$formatter.replaceCommaWithDotCal(acc) + self.$formatter.replaceCommaWithDotCal(val)
        }, null)
      } else return null
    },
    $_getCurrentDate () {
      return moment(new Date()).format('DD.MM.YYYY')
    },
    $_groupBy (array, key) {
      return array.reduce(function (total, item) {
        total[item[key]] = total[item[key]] || []
        total[item[key]].push(item)
        return total
      }, {})
    },
    // _findValueInArray([{ n: 4, b: 10 }, { n: 2, b: 11 }], x => x.b === 10) // { n: 4, b: 10 }
    $_findValueInArray (array, condition) {
      let getObj = array.find(condition)
      if (getObj) return getObj
      else return null
    },
    // _getSingleValueFromObject([{ n: 4, b: 10 }, { n: 2, b: 11 }], x => x.b) // [10, 11]
    $_mapDataInArray (array, condition) {
      let getObj = array.map(condition)
      if (getObj) return getObj
      else return null
    },
    /* {
        number: { list:['qty', 'price'], format: 'replaceCommaWithDot' },
        date: { list:['start', 'end'], from: 'DD.MM.YYYY', to: 'YYYY.MM.DD'},
        status: { list:['status'], text: '', value: '$_ccsheetStatus' },
        merge: { list:['firstname', 'lastname'], property: 'username' }
    */
    $_formatModel (model, data) {
      model = JSON.parse(JSON.stringify(model))
      let keys = Object.keys(data)
      keys.forEach(key => {
        switch (key) {
          case this.NUMBER: {
            let formatObj = data[this.NUMBER]
            formatObj[this.LIST].forEach(item => {
              model[item] = this.$formatter[formatObj[this.FORMAT]](model[item])
            })
            break
          }
          case this.DATE: {
            let formatObj = data[this.DATE]
            formatObj[this.LIST].forEach(item => {
              let dateObj = this.$formatter.formatDate(model[item], formatObj[this.FROM], formatObj[this.TO])
              model[item] = dateObj
            })
            break
          }
          case this.STATUS: {
            let formatObj = data[this.STATUS]
            formatObj.forEach(item => {
              item[this.LIST].forEach(record => {
                let statusArray = this[item[this.VALUE]]
                statusArray.map(function (x) {
                  if (x.value === model[record]) model[record] = { text: x.text, value: model[record] }
                })
              })
            })
            break
          }
          case 'merge': {
            let formatObj = data['merge']
            model[formatObj['property']] = `${model[formatObj[this.LIST][0]] || ''} ${model[formatObj[this.LIST][1]] || ''}`
            break
          }
          case this.ADJUSTMENTORDER: {
            // model.receivedqty = model.qty
            break
          }
          default:
            break
        }
      })
      return model
    },
    // Array of $_formatModel FUNCTION
    $_formatListModel (listOfModel, data) {
      if (this.$formatter.isArrayHasData(listOfModel)) {
        let result = []
        listOfModel.forEach(model => {
          result.push(this.$_formatModel(model, data))
        })
        return result
      } else return []
    },
    $_sortByType (item1, item2) {
      if (typeof (item1) === 'string' && typeof (item2) === 'string') {
        if (/^\d+$/.test(item2) && /^\d+$/.test(item1)) {
          return item1.localeCompare(item2, undefined, {
            numeric: true
          })
        }
        return item1.localeCompare(item2)
      } else {
        return item1 < item2 ? -1 : 1
      }
    },
    $_customSorting (items, index, isDesc, dateColumnArray, type) {
      items.sort((a, b) => {
        if (dateColumnArray.includes(index)) {
          let date1 = a[index]
          let date2 = b[index]
          if (!isDesc) {
            return this.$_sortWithDates(date1, date2, type)
          } else {
            return this.$_sortWithDates(date2, date1, type)
          }
        } else {
          if (!a[index]) a[index] = ''
          if (!b[index]) b[index] = ''
          if (!isDesc) {
            return this.$_sortByType(a[index], b[index])
          } else {
            return this.$_sortByType(b[index], a[index])
          }
        }
      })
      return items
    },
    $_sortWithDates (date1, date2, type) {
      if (date1 === '' || date1 === null) return -1
      if (date2 === '' || date2 === null) return 1
      var dateA = moment(date1, type)
      var dateB = moment(date2, type)
      return dateA - dateB
    },
    // Set Foreground color based on the background color
    $_foreGroundColor (colorValue) {
      let rgbCode = colorValue ? this.$_hexToRgbA(colorValue) : ''
      let color = rgbCode ? rgbCode.toString().split('(')[1] : ''
      let resultOnColor = color.split(',', 3)
      let R, G, B, C, L
      R = resultOnColor[0]
      G = resultOnColor[1]
      B = resultOnColor[2] ? resultOnColor[2].toString().replace(')', '') : 0
      C = [R / 255, G / 255, B / 255]
      for (var i = 0; i < C.length; ++i) {
        if (C[i] <= 0.03928) {
          C[i] = C[i] / 12.92
        } else {
          C[i] = Math.pow((C[i] + 0.055) / 1.055, 2.4)
        }
      }
      L = 0.2126 * C[0] + 0.7152 * C[1] + 0.0722 * C[2]
      if (L > 0.179) {
        return 'black'
      } else {
        return 'white'
      }
    },
    $_hexToRgbA (hex) {
      hex = hex.slice(0, -2)
      var c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',1)'
      }
      return null
    },
    $_downloadExportedReport (filename) {
      return new Promise((resolve, reject) => {
        window.open(`${process.env.VUE_APP_URL}file/download/?fileName=${filename}`, '_blank')
        resolve()
      })
    },
    getMimeTypeIcons (fileType) {
      let iconObj = {}
      switch (fileType) {
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          iconObj = {
            icon: 'mdi-file-word',
            color: 'primary'
          }
          break
        case 'application/pdf':
          iconObj = {
            icon: 'mdi-file-pdf-box',
            color: 'red'
          }
          break
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          iconObj = {
            icon: 'mdi-file-excel',
            color: 'green'
          }
          break
        default:
          iconObj = {
            icon: 'mdi-file',
            color: 'primary'
          }
      }
      return iconObj
    },
    toBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    $_removeEmptyFromObject (obj) {
      return Object.entries(obj)
        .filter(([_, v]) => v != null)
        .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
    },
    $_removeEmptyFromObjectIteration (obj) {
      return Object.entries(obj)
        .filter(([_, v]) => v != null)
        .reduce(
          (acc, [k, v]) => ({ ...acc, [k]: v === Object(v) ? this.$_removeEmptyFromObj(v) : v }),
          {}
        )
    },
    $_checkOrganzationExistsInElma (organizationnumber) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `customers/check_organization_exists?orgNumber=${organizationnumber || ''}`).then(({ data }) => {
          resolve(!!data)
        })
      })
    }
  }
}
